import styles from 'styles/FillingWrapper.module.css'
const Wrapper = ({ children }) =>
    <div className={styles.wrap}>
        { children }
    </div>
export default Wrapper